<template>
  <div class="content">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="140px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型" prop="poolType">
            <el-select v-model="propsParams.poolType" placeholder="类型" filterable clearable @change="poolTypeChange">
              <el-option v-for="item in webPoolType" :key="item.label" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="代理商" prop="userId">
            <el-select v-model="propsParams.userId" placeholder="代理商" filterable clearable>
              <el-option v-for="item in webAgentList" :key="item.userId" :label="item.company" :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="流量池名称" prop="poolName">
            <el-input v-model="propsParams.poolName" placeholder="池名称"></el-input>
          </el-form-item>
          <el-form-item label="运营商" prop="operationType">
            <el-select v-model="propsParams.operationType" placeholder="运营商" multiple filterable clearable>
              <el-option v-for="item in webPoolOperators" :key="item.label" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注信息" prop="remark">
            <el-input v-model="propsParams.remark" placeholder="备注信息"></el-input>
          </el-form-item>
          <el-form-item label="卡用量展示" prop="showFlow">
            <el-switch v-model="propsParams.showFlow" active-color="#13ce66" inactive-color="#DCDFE6" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="启用状态" prop="status">
            <el-switch v-model="propsParams.status" active-color="#13ce66" inactive-color="#DCDFE6" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="12" >
          <el-form-item label="单卡月峰值" prop="singleFlowLimit" >
            <el-input v-model="propsParams.singleFlowLimit" placeholder="每张卡每月峰值">
              <template slot="append">MB</template>
            </el-input>
          </el-form-item>
          <el-form-item label="单卡停机保号费" prop="cardProductFee" >
            <el-input v-model="propsParams.cardProductFee" placeholder="每张卡每月停机所交费用">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="单卡功能管理费" prop="cardFunctionFee" >
            <el-input v-model="propsParams.cardFunctionFee" placeholder="每张卡每月所交功能管理费">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>

          <div v-if="isSingleCardMode">
            <el-form-item label="单卡低消流量" prop="singleFlow" >
              <el-input v-model="propsParams.singleFlow" placeholder="保底的流量">
                <template slot="append">MB</template>
              </el-input>
            </el-form-item>
            <el-form-item label="单卡低消费用" prop="singlePrice" >
              <el-input v-model="propsParams.singlePrice" placeholder="单卡低消流量对应的费用">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="超流单价" prop="flowPrice">
              <el-input v-model="propsParams.flowPrice" placeholder="超出的流量价格">
                <template slot="append">元/GB</template>
              </el-input>
            </el-form-item>
          </div>

          <div v-if="isTotalFlowMode">
            <el-form-item label="池总量" prop="flow">
              <el-input v-model="propsParams.poolTotalFlow" placeholder="池总量">
                <template slot="append">MB</template>
              </el-input>
            </el-form-item>
            <el-form-item label="流量池单价" prop="flowPrice">
              <el-input v-model="propsParams.flowPrice" placeholder="流量池价格">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>

          <div v-if="isSetMealMode">
            <el-form-item label="单卡月流量" prop="singleFlow" >
              <el-input v-model="propsParams.singleFlow" placeholder="每月单卡可用流量">
                <template slot="append">MB</template>
              </el-input>
            </el-form-item>
            <el-form-item label="单卡月费用" prop="singlePrice">
              <el-input v-model="propsParams.singlePrice" placeholder="每月单卡需支付金额">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>

          <div v-if="isPostPayment">
            <el-form-item label="流量单价" prop="singlePrice">
              <el-input v-model="propsParams.singlePrice" placeholder="每GB流量单价">
                <template slot="append">元/GB</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col>

      </el-row>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { poolSavePool } from "@/api/api.js";
import { agentDataList } from "@/api/api.js";
export default {
  name:"pondAdd",
  data() {
    return{
      propsParams:{
        status:"1",
        showFlow:"1",
      },
      isSingleCardMode:false,
      isTotalFlowMode:false,
      isSetMealMode:false,
      isPostPayment:false,
      ruleValidate:{
        poolName:[
          { required: true, message: "请输入流量池名称", trigger: "blur" },
          { min: 3,max: 18,message: "请输入3至18字母数字或汉字",trigger: "blur"},
        ],
        userId:[
          { required: true, message: "请选择代理商", trigger: "blur" },
        ],
        poolType:[
          { required: true, message: "请选择类型", trigger: "blur" },
        ],
        operationType:[
          { required: true, message: "请选择运营商", trigger: "blur" },
        ],
        singleFlowLimit:[
          { required: true, message: "请选择单卡月峰值", trigger: "blur" },
        ],
        cardProductFee:[
          { required: true, message: "请选择单卡停机保号费", trigger: "blur" },
        ],
        cardFunctionFee:[
          { required: true, message: "请选择单卡功能管理费", trigger: "blur" },
        ],
      },
      webAgentList:[],
      webPoolType:[
        { value:"1",label:"单卡模式" },
        { value:"2",label:"总量模式" },
        { value:"3",label:"套餐模式" },
        { value:"5",label:"后付款模式" },
      ],
      webPoolOperators:[
        { value:"3",label:"中国电信" },
        { value:"1",label:"中国移动" },
        { value:"2",label:"中国联通" },
      ],
    }
  },
  methods: {
    // 获取流量池用户
    initData(){
      agentDataList({commissionModel:'2'}).then(res => {
        this.webAgentList = res.data.data
      })
    },
    // 创建流量池
    handleSubmit(){
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          let params ={
            ...this.propsParams
          }
          poolSavePool(params).then(res => {
            this.$message.success("添加流量池成功");
            this.propsParams = {};
            this.propsParams = {
                status:"1",
                showFlow:"1",
              }
            this.$router.push(`/pondManage/pondList`);
          })
        }
      })
    },
    poolTypeChange(selectValue){
      if (selectValue === "1") { // 单卡模式
        this.isSingleCardMode = true;
        this.isTotalFlowMode = false;
        this.isSetMealMode = false;
        this.isPostPayment = false;
      } else if (selectValue === "2") { // 总量模式
        this.isSingleCardMode = false;
        this.isTotalFlowMode = true;
        this.isSetMealMode = false;
        this.isPostPayment = false;
      }else if (selectValue === "3") { // 套餐模式
        this.isSingleCardMode = false;
        this.isTotalFlowMode = false;
        this.isSetMealMode = true;
        this.isPostPayment = false;
      }else if (selectValue === "5") { // 后付款模式
        this.isSingleCardMode = false;
        this.isTotalFlowMode = false;
        this.isSetMealMode = false;
        this.isPostPayment = true;
      }
    }
  },
  created() {
    this.initData()
  }
};
</script>

<style scoped lang="less">

</style>


